<template>
  <v-select
    v-bind="$attrs"
    :disabled="current ? false : !id"
    :items="items"
    return-object
    hide-details
    item-text="title"
    item-value="id"
    no-data-text="Нажаль: у цього клієнта немає проектів"
    dense
    outlined
    :clearable="clearable"
    @change="$emit('input', $event)"
  />
</template>

<script>
import { getProjects } from "@/backend/clientsApi.js";
import { getClientProjects } from "@/backend/clientDashboardApi.js";

export default {
  props: {
    id: {
      type: [String, Number],
    },
    current: {
      default() {
        return false;
      },
    },
  },
  data: () => ({
    items: [],
  }),
  computed: {
    clearable() {
      return this.current ? this.items.length !== 1 : true;
    },
  },
  watch: {
    id: {
      async handler(val) {
        if (this.current) {
          this.items = await getClientProjects();
          if (this.items.length == 1) {
            this.$emit("input", this.items[0]);
          }
        } else if (val) {
          this.items = await getProjects(this.id);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped></style>
